<template>
  <div class="stage-wrap">
      <st-sign v-if="nowTime < preBegin" />
      <st-pre v-else-if="nowTime <= finalBegin" />
      <st-final v-else-if="nowTime > finalBegin" />
      <div v-else class="txt-loading">数据加载中…</div>
  </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex'
  import Sign from './sign'
  import Pre from './pre'
  import Final from './final'

  export default {
    props: [],
    components: {
      [Sign.name]: Sign,
      [Pre.name]: Pre,
      [Final.name]: Final
    },
    computed: {
      ...mapGetters(['nowTime', 'preBegin', 'finalBegin'])
    }
  }

</script>
